export const types = <const>{
	mutations: {
		GET_PERM: 'getPerm',
	},
	actions: {
		GET_ROLE_TREE_VIEW: 'getRoleBaseTreeView',
	},
};
